module.exports = __webpack_public_path__ + "img/19.2fc6cb0b.png";